export const DATASET_WHATSAPP = 'whatsapp_templates';
export const DATASET_INTERVENE = 'intervene';

export function usesIndependentScope(dataset) {
  return dataset === DATASET_WHATSAPP || dataset === DATASET_INTERVENE;
}
